import { useState } from 'react';
import { avatarUrl, initials } from '@/lib/format';

interface Props {
  name: string;
  login: string | null;
  size?: number;
  className?: string;
}

export default function Avatar({ name, login, size = 32, className = '' }: Props) {
  const [failed, setFailed] = useState(false);
  const url = !failed && login ? avatarUrl(login, size * 2) : null;

  return (
    <div
      className={`relative inline-flex items-center justify-center rounded-full overflow-hidden bg-accent-100 dark:bg-surface text-accent-700 dark:text-accent-200 font-semibold select-none shrink-0 ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      aria-label={name}
    >
      {url ? (
        <img
          src={url}
          alt=""
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        <span>{initials(name)}</span>
      )}
    </div>
  );
}
